module.exports = __webpack_public_path__ + "07_face.249d11c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/kanai/male/layer1/07_face.png
// module id = 9tWY
// module chunks = 0